import NameStars from './NameStars';

export default NameStars;
